import { render } from "./AbogSwitch.vue?vue&type=template&id=78028cae&scoped=true"
import script from "./AbogSwitch.vue?vue&type=script&lang=js"
export * from "./AbogSwitch.vue?vue&type=script&lang=js"

import "./AbogSwitch.vue?vue&type=style&index=0&id=78028cae&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78028cae"]])

export default __exports__